import React, { Component } from 'react';
import classNames from 'classnames';

export function InsertHrButton({ theme, store, onInsert }) {
	const disabled = store && store.getEditorEnviorment() !== 'root';
	return (
		<div
			className={theme.buttonWrapper}
			title="插入水平线">
			<button
				className={theme.button}
				onClick={onInsert}>
				<i className={"qa-ico-hr"} />
			</button>
		</div>
	)
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/hrPlugin/InsertHrButton.jsx